<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
	<draggable-dialog class="draggableDialog" id="attrDialog" :show="true" :closable="false"
    width="100%"
		top="0px" 
  >
		<template #header>
      <div>
        <slot name="header">
          <span class="headerLabel">多选元素处理</span>
          <div style="clear: both;"></div>
        </slot>
      </div>
		</template>
    <template #content>
      <div :style="{'height': '415px'}">
        <slot name="content">
          <div style="display: flex;justify-content: center;align-items: center;margin-top: 5px;margin-bottom: 5px;">
            <el-button type="primary" style="margin-right: 10px" @click="handleAlignLeft">向左对齐</el-button>
            <el-button type="primary" @click="handleAlignRight">向右对齐</el-button>
          </div>
          <div style="display: flex;justify-content: center;align-items: center;margin-top: 5px;margin-bottom: 5px;">
            <el-button type="primary" style="margin-right: 10px" @click="handleAlignTop">向上对齐</el-button>
            <el-button type="primary" @click="handleAlignBottom">向下对齐</el-button>
          </div>
          <div style="display: flex;justify-content: center;align-items: center;margin-top: 5px;margin-bottom: 5px;">
            <el-button type="primary" style="margin-right: 10px" @click="handleHorizontalCenter">水平居中</el-button>
            <el-button type="primary" @click="handleVerticalCenter">垂直居中</el-button>
          </div>
          <div style="display: flex;justify-content: center;align-items: center;margin-top: 5px;margin-bottom: 5px;">
            <el-button type="primary" style="margin-right: 10px" @click="handleHorizontalDivide">水平均分</el-button>
            <el-button type="primary" @click="handleVerticalDivide">垂直均分</el-button>
          </div>
          <span>---------------------------------------</span>
          <div style="display: flex;justify-content: center;align-items: center;margin-top: 5px;margin-bottom: 5px;">
            <el-button type="primary" @click="handleUniformSize">统一大小</el-button>
          </div>
          <div style="display: flex;justify-content: center;align-items: center;margin-top: 5px;margin-bottom: 5px;">
            <el-button type="primary" style="margin-right: 10px" @click="handleAddCombination">设为组合</el-button>
            <el-button type="primary" @click="handleDeleteCombination">取消组合</el-button>
          </div>
        </slot>
      </div>
    </template>
	</draggable-dialog>
</template>

<script>
	import DraggableDialog from "@/components/ProductComponents/CreateComponents/DraggableDialog";

	export default {
		name: 'AttrDialog',
		components: {
      DraggableDialog
		},
		props: {

		},
		data() {
			return {
			}
		},
    methods:{
      handleAlignLeft(){
        this.$emit("multi-option","align-left");
      },
      handleAlignRight(){
        this.$emit("multi-option","align-right");
      },
      handleAlignTop(){
        this.$emit("multi-option","align-top");
      },
      handleAlignBottom(){
        this.$emit("multi-option","align-bottom");
      },
      handleHorizontalCenter(){
        this.$emit("multi-option","horizontal-center");
      },
      handleVerticalCenter(){
        this.$emit("multi-option","vertical-center");
      },
      handleHorizontalDivide(){
        this.$emit("multi-option","horizontal-divide");
      },
      handleVerticalDivide(){
        this.$emit("multi-option","vertical-divide");
      },
      handleUniformSize(){
        this.$emit("multi-option","uniform-size");
      },
      handleAddCombination(){
        this.$emit("add-combination");
      },
      handleDeleteCombination() {
        this.$emit("delete-combination");
      }

    }
	}

</script>

<style lang="less" scoped>
	#attrDialog {
		.headerLabel {
			max-width: 18em;
			display: inline-block;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			float: left;
		}

		.headerId {
			margin-left: 10px;
			float: left;

			span {
				float: left;
			}
		}

		.editIdBtn {
			display: inline-block;
			margin-left: 2px;
			cursor: pointer;
			float: left;
		}

		.confirmBtn {
			display: inline-block;
			margin-left: 10px;
			cursor: pointer;
			float: left;
		}

		.cancelBtn {
			display: inline-block;
			margin-left: 10px;
			cursor: pointer;
			float: left;
		}

		.editIdInput {
			display: inline-block;
			float: left;

			/deep/ .u-input__input {
				height: 20px !important;
				line-height: 20px !important;
				min-height: 10px !important;
			}

			margin-left: 5px !important;
		}

		///deep/ .forms {
		//	max-height: 397px;
		//	min-height: 397px;
		//	// width:80%;
		//	overflow-y: auto;
		//}
    //
		///deep/ .forms2 {
		//	max-height: 500px;
		//	width:95%;
		//	overflow-y: auto;
		//}

		/deep/ .eventsCollapseItem {
			.addEventBtn {
				border: none;
				margin-bottom: 20px;
			}

			.eventItem {
				height:90px;
				line-height: 50px;
				// display: flex;
				// justify-content: space-between;
				align-items: center;
                .div{
					display: flex;
					align-items: center;
					height: 30px;
				} 
				.deleteEventBtn {
					padding: 10px;
					margin-left: 5px;
					height: 15px;
					background-color: rgb(250, 96, 96);
					color: white;
				}
			}
		}

		/deep/ .variablesEventForms {
			.addVariablesEventBtn {
				background-color: transparent;
				border: none;
				color: black;
				margin-bottom: 20px;
			}

			.variablesEventItem {
				height: 60px;
				line-height: 50px;
				// display: flex;
				// justify-content: space-between;
				align-items: center;
          .div1{
            display: flex;
            align-items: center;
            height: 30px;
          }
				.deleteVariablesEventBtn {
					padding: 10px;
					margin: 0;
					height: 15px;
					background-color: rgb(250, 96, 96);
					color: white;
				}
			}
		}
		/deep/ .bottomBtns {
			display: flex;
			justify-content: space-between;
			margin-top: 5px;  //按钮解决遮盖上面文字的问题
			.btn {
				margin: 0;
				width: 30%;

				.btnIcon {
					margin-right: 10px;
				}
			}

			.deleteBtn {
				background-color: rgb(250, 53, 52);
				color: white;
				height:35px;  //把按钮弄小解决遮盖上面文字问题
			}

			.saveBtn {
				background-color: rgb(25, 190, 107);
				color: white;
				height:35px;
			}

			.resetBtn {
				background-color: rgb(60, 156, 255);
				color: white;
				height:35px;
			}

		}
	}
</style>
